(function () {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var menuToggle = document.querySelector('[data-menu-toggle]');
  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      var isOpen = document.body.classList.toggle('is-menu-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  var enquiryForm = document.getElementById('RetreatContactForm') || document.querySelector('.form-card form');
  if (enquiryForm) {
    enquiryForm.addEventListener('submit', function () {
      var summaryField = enquiryForm.querySelector('[data-enquiry-summary]');
      if (!summaryField) return;

      function fieldValue(name) {
        var field = enquiryForm.querySelector('[name="' + name + '"]');
        return field && field.value ? field.value.trim() : "";
      }

      var accepted = enquiryForm.querySelector('[name="contact[accepted_boundary]"]');
      var lines = [
        "RetreatCN private health-check retreat enquiry",
        "",
        "Name: " + fieldValue("contact[name]"),
        "Email: " + fieldValue("contact[email]"),
        "WhatsApp / preferred written contact: " + fieldValue("contact[phone]"),
        "Travel window: " + fieldValue("contact[travel_window]"),
        "Interest: " + fieldValue("contact[interest]"),
        "Boundary accepted: " + (accepted && accepted.checked ? "Yes" : "No"),
        "",
        "Message:",
        fieldValue("contact[message]"),
        "",
        "Internal handling note: this enquiry was submitted through RetreatCN.co.uk. Please do not request detailed medical records through normal email unless a secure provider process has been confirmed."
      ];

      summaryField.value = lines.join("\n");
    });
  }

  var videoModal = document.querySelector('[data-video-modal]');
  var videoPlayer = videoModal ? videoModal.querySelector('[data-video-player]') : null;
  var videoTitle = videoModal ? videoModal.querySelector('[data-video-title]') : null;
  var lastVideoTrigger = null;

  function closeDestinationVideo() {
    if (!videoModal || !videoPlayer) return;
    videoPlayer.pause();
    videoPlayer.removeAttribute('src');
    videoPlayer.removeAttribute('poster');
    videoPlayer.load();
    videoModal.hidden = true;
    document.body.classList.remove('is-video-modal-open');
    if (lastVideoTrigger) lastVideoTrigger.focus();
  }

  function openDestinationVideo(trigger) {
    if (!videoModal || !videoPlayer || !trigger) return;
    var src = trigger.getAttribute('data-video-src');
    if (!src) return;

    var activeHeroVideo = document.querySelector('[data-hero-video]');
    var activeSoundToggle = document.querySelector('[data-sound-toggle]');
    heroSoundRequested = false;
    if (activeHeroVideo) {
      activeHeroVideo.muted = true;
      activeHeroVideo.defaultMuted = true;
      activeHeroVideo.setAttribute('muted', '');
    }
    if (activeSoundToggle) {
      activeSoundToggle.classList.remove('is-audio-on');
      activeSoundToggle.setAttribute('aria-pressed', 'false');
      activeSoundToggle.setAttribute('aria-label', 'Play video sound');
    }

    lastVideoTrigger = trigger;
    if (videoTitle) videoTitle.textContent = trigger.getAttribute('data-video-title') || 'Destination video';
    videoPlayer.src = src;
    videoPlayer.poster = trigger.getAttribute('data-video-poster') || '';
    videoPlayer.muted = false;
    videoPlayer.controls = true;
    videoModal.hidden = false;
    document.body.classList.add('is-video-modal-open');
    videoPlayer.focus();

    var playPromise = videoPlayer.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  Array.prototype.slice.call(document.querySelectorAll('[data-video-open]')).forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      openDestinationVideo(trigger);
    });
  });

  if (videoModal) {
    Array.prototype.slice.call(videoModal.querySelectorAll('[data-video-close]')).forEach(function (closer) {
      closer.addEventListener('click', closeDestinationVideo);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && videoModal && !videoModal.hidden) closeDestinationVideo();
  });

  var slider = document.querySelector('[data-slider]');
  if (!slider) return;

  var slides = Array.prototype.slice.call(slider.querySelectorAll('.slide'));
  var prev = slider.querySelector('[data-prev]');
  var next = slider.querySelector('[data-next]');
  var heroVideo = slider.querySelector('[data-hero-video]');
  var soundToggle = slider.querySelector('[data-sound-toggle]');
  var index = 0;
  var timer = null;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heroSoundRequested = false;

  function prepareHeroVideo() {
    if (!heroVideo) return;
    heroVideo.autoplay = true;
    heroVideo.loop = true;
    heroVideo.playsInline = true;
    heroVideo.preload = 'auto';
    heroVideo.setAttribute('autoplay', '');
    heroVideo.setAttribute('loop', '');
    heroVideo.setAttribute('preload', 'auto');
    heroVideo.setAttribute('playsinline', '');
    heroVideo.setAttribute('webkit-playsinline', '');
    if (!heroSoundRequested) {
      heroVideo.muted = true;
      heroVideo.defaultMuted = true;
      heroVideo.setAttribute('muted', '');
    }
  }

  function attemptHeroPlay() {
    if (!heroVideo || reduceMotion) return;
    prepareHeroVideo();
    var firstSlide = slides[0];
    if (firstSlide && !firstSlide.classList.contains('is-active')) return;
    if (heroVideo.readyState === 0) {
      try {
        heroVideo.load();
      } catch (error) {}
    }
    var playPromise = heroVideo.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  function syncSoundToggle() {
    if (!soundToggle || !heroVideo) return;
    var isOn = !heroVideo.muted;
    soundToggle.classList.toggle('is-audio-on', isOn);
    soundToggle.setAttribute('aria-pressed', String(isOn));
    soundToggle.setAttribute('aria-label', isOn ? 'Mute video sound' : 'Play video sound');
  }

  function syncSlideVideo(slide, isActive) {
    var videos = Array.prototype.slice.call(slide.querySelectorAll('video'));
    videos.forEach(function (video) {
      if (isActive) {
        if (video === heroVideo && heroVideo.muted) prepareHeroVideo();
        var playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      } else {
        if (video === heroVideo) {
          video.muted = true;
          syncSoundToggle();
        }
        video.pause();
      }
    });
  }

  function show(nextIndex) {
    index = (nextIndex + slides.length) % slides.length;
    slides.forEach(function (slide, slideIndex) {
      var isActive = slideIndex === index;
      slide.classList.toggle('is-active', isActive);
      syncSlideVideo(slide, isActive);
    });
  }

  function start() {
    if (heroVideo && !heroVideo.muted) return;
    if (reduceMotion || timer || slides.length < 2) return;
    timer = window.setInterval(function () {
      show(index + 1);
    }, 6500);
  }

  function stop() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  if (prev) {
    prev.addEventListener('click', function () {
      stop();
      show(index - 1);
      start();
    });
  }

  if (next) {
    next.addEventListener('click', function () {
      stop();
      show(index + 1);
      start();
    });
  }

  if (soundToggle && heroVideo) {
    prepareHeroVideo();
    syncSoundToggle();
    soundToggle.addEventListener('click', function () {
      var wantsSound = heroVideo.muted;
      heroSoundRequested = wantsSound;
      if (wantsSound) {
        heroVideo.muted = false;
        heroVideo.defaultMuted = false;
        heroVideo.removeAttribute('muted');
        stop();
        var playPromise = heroVideo.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      } else {
        heroSoundRequested = false;
        prepareHeroVideo();
        start();
      }
      syncSoundToggle();
    });
  }

  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);
  show(0);
  attemptHeroPlay();
  if (heroVideo) {
    ['loadedmetadata', 'canplay', 'canplaythrough'].forEach(function (eventName) {
      heroVideo.addEventListener(eventName, attemptHeroPlay, { once: true });
    });
    window.setTimeout(attemptHeroPlay, 250);
    window.setTimeout(attemptHeroPlay, 1250);
  }
  window.addEventListener('load', attemptHeroPlay);
  window.addEventListener('pageshow', attemptHeroPlay);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) attemptHeroPlay();
  });
  document.addEventListener('pointerdown', attemptHeroPlay, { once: true });
  document.addEventListener('touchstart', attemptHeroPlay, { once: true });
  start();
})();
